import { render, staticRenderFns } from "./ChallengeCenter.vue?vue&type=template&id=07bfc4b8&scoped=true&lang=pug&"
import script from "./ChallengeCenter.vue?vue&type=script&lang=js&"
export * from "./ChallengeCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bfc4b8",
  null
  
)

export default component.exports